import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {MatStepper, MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import Swal from 'sweetalert2';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';

import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {HeaderComponent} from '../../header/header.component';
import {FooterComponent} from '../../footer/footer.component';
import {NumericDirective, NumericDirective2} from '../../../validaciones/directives/numeric.directive';
import {MatIconModule} from '@angular/material/icon';

import {DireccionDirective} from '../../../validaciones/directives/direccion.directive';
import {AlphanumericDirective2, lettersDirective} from '../../../validaciones/directives/lettersDirective.directive';
import {PlacaDirective} from '../../../validaciones/directives/placa.directive';
import {CatEfectoCertificado} from '../../../service/catEfectoCertificado.service';
import {CatCoberturaCertificados} from '../../../service/catCoberturaCertificados.service';
import {CatalogoDomicilioGenericoService} from "../../../service/catalogoDomicilioGenerico.service";
import {ImprimirSolicitudCdniGenerico} from '../../../service/imprimirSolicitudCdniGenerico.service'
import {EliminarDocumentos} from '../../../service/eliminarDocumentos.service';


// Importaciones para la consulta del servicio
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  fromEvent,
  map,
  of,
  Subject, switchMap,
  takeUntil,
  tap
} from 'rxjs';
import {validadorReutilizable} from '../../../shared/utils/validadores';
import {SolicitarCertificadoForaneoMoralService} from '../../../service/solicitarCertificadoForaneoMoral.service';
import {PayloadMoralForanea} from '../../../pojos/PayloadMoralForanea'
import {SolicitudVo} from '../../../pojos/solicitudVo';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {DocumentoService} from '../../../service/cargarDocumentos.service';
import {toUpercaseDirective} from '../../../validaciones/directives/toUpercase.Direcitve';
import {Router} from '@angular/router';
import { AlphanumericDirective } from '../../../validaciones/directives/alphanumeric.directive';

@Component({
  selector: 'app-persona-moral-foranea',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    AlphanumericDirective,
    PlacaDirective,
    lettersDirective,
    DireccionDirective,

    toUpercaseDirective,
    NumericDirective2,
    AlphanumericDirective2,
  ],
  templateUrl: './persona-moral-foranea.component.html',
  styleUrl: './persona-moral-foranea.component.css'
})

export class PersonaMoralForaneaComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('fechaConstitucionInput', {static: false}) fechaConstitucionInput!: ElementRef;
  @ViewChild('sexoInput', {static: false}) sexoInput!: ElementRef;
  @ViewChild('fechaNacimientoInput', {static: false}) fechaNacimientoInput!: ElementRef;

  @Input() solicitudVo!: SolicitudVo;
  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  @Input() localidad: Array<any> = [];
  @Input() municipio!: string;
  @Input() estado!: string;
  @Input() idMunicipio!: string;
  @Input() idEstado!: string;
  @Input() cp!: any;
  @Input() Message!: string;

  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;
  SeptimoFormGroup!: FormGroup;
  OctavoFormControl!: FormGroup;

  mostrarSpinner = false;
  isLinear = false;
  private destroy$ = new Subject<void>();

  isUploading: { [key: string]: boolean } = {};
  uploadProgress: { [key: string]: number } = {};

  constructor(
    private _formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private solicitudService: SolicitarCertificadoForaneoMoralService,
    private elementRef: ElementRef,
    private cd: ChangeDetectorRef,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private catalogoDomicilioGenerico: CatalogoDomicilioGenericoService,
    private imprimirSolicitudService: ImprimirSolicitudCdniGenerico,
    private documentoService: DocumentoService,
    private eliminarDocumentoService: EliminarDocumentos,
    private router: Router
  ) {
    this.solicitudVo = new SolicitudVo();
    this.catCoberturaCertificados();
    this.catEfectoCertificado();
    this.Message = this.catalogoDomicilioGenerico.getDomicilioMessage();
  }

  ngOnInit(): void {
    this.PrimerFormGroup = this._formBuilder.group({
      niv: ['', [Validators.required, validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        intLongitudMinima: 10,
        intLongitudMaxima: 17
      })]],
      placa: ['', [Validators.required, validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        blnPermitirGuionMedio: true, intLongitudMinima: 6, intLongitudMaxima: 10
      })]],
      motivo: ['', Validators.required],
      certificadoPor: ['', Validators.required],
      tipoServicio: ['', Validators.required],
      categoria: ['', Validators.required],
      marca: ['', Validators.required],
      submarca: ['', Validators.required],
      modelo: ['', [Validators.required, Validators.pattern('^[0-9]{4}$'),]],
      motor: ['', Validators.required],
      refrendo: ['', [Validators.required, Validators.pattern('^[0-9]{4}$'),
      ]],
      repuve: ['', Validators.required],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfcMoral: ['', [Validators.required, Validators.pattern(/^[A-ZÑ&]{3}[0-9]{6}[A-Z0-9]{3}$/i)]],
      fechaConstitucion: ['', Validators.required],
      razonSocial: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirCaracteresEspecialesEmpresa: true,
          blnPermitirPuntos: true,
          blnPermitirEspacios: true,
          blnPermitirAcentos: true,
        })
      ]]
    });

    this.TercerFormGroup = this._formBuilder.group({
      calle: ['', Validators.required],
      numExterior: ['', Validators.required],
      numInterior: [''],
      codigoPostal: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]],
      estado: ['', Validators.required],
      municipio: ['', Validators.required],
      localidad: ['', Validators.required],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      numeroTelefono: ['', [Validators.required, Validators.pattern(/^\d{10}$/),
      ]],
      correoElectronico: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    });

    this.QuintoFormGroup = this._formBuilder.group({
      rfc: ['', [Validators.required, Validators.pattern(/^[A-ZÑ&]{4}\d{6}[A-Z\d]{3}$/i)]],
      curp: ['', [Validators.required, Validators.pattern(/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/)]],
      nombre: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,
        })
      ]],
      apellidoPaterno: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,
        })
      ]],
      apellidoMaterno: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,
        })
      ]],
      sexo: ['', Validators.required],
      fechaNacimiento: ['', Validators.required],
    });

    this.SextoFormGroup = this._formBuilder.group({
      documentos: [false, Validators.requiredTrue]
    });

    this.SeptimoFormGroup = this._formBuilder.group({
      actaConstitutiva: ['', Validators.required],
      factura: ['', Validators.required],
      ine: ['', Validators.required],
      poderNotarial: ['', Validators.required],
      repuveDoc: ['', Validators.required],
      solicitud: ['', Validators.required],
      tenencia: ['', Validators.required],
    });

    this.OctavoFormControl = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue]
    });

    this.inicializarValidacionesReactivas();
    this.TercerFormGroup.get('codigoPostal')?.valueChanges.pipe(
      // Espera 500 milisegundos después de que el usuario dejó de teclear
      debounceTime(500),

      // Solo continúa si el valor actual es diferente al anterior
      distinctUntilChanged(),

      // Filtra para que la lógica solo se ejecute si la longitud es 5
      // Esta línea ya ayuda a prevenir que pasen valores nulos o vacíos
      filter((value: string | null): value is string => !!value && value.length === 5)
    ).subscribe((value: string) => {

      this.getListlocalidad(value);
    });
  }


  ngAfterViewInit() {
    // ========== INICIA CÓDIGO PARA VALIDACIÓN DE RFC MORAL ==========
    const rfcMoralControl = this.SegundoGrupo.get('rfcMoral');
    if (rfcMoralControl) {
      const rfcMoralField = this.elementRef.nativeElement.querySelector('[formControlName="rfcMoral"]');

      fromEvent(rfcMoralField, 'blur').pipe(
        filter(() => rfcMoralControl.valid && rfcMoralControl.value.length === 12),
        map(() => rfcMoralControl.value),
        // distinctUntilChanged(),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        const fechaInferida = inferirFechaConstitucion(rfcMoralControl.value);
        if (fechaInferida) {
          this.SegundoGrupo.get('fechaConstitucion')?.setValue(fechaInferida);
          this.aplicarEstilosDeshabilitado(this.fechaConstitucionInput);
        }
      });
      rfcMoralControl.valueChanges.pipe(
        filter(() => rfcMoralControl.invalid),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        const fechaConstitucionControl = this.SegundoGrupo.get('fechaConstitucion');
        if (rfcMoralControl.invalid) {
          fechaConstitucionControl?.reset('')
          this.removerEstilosDeshabilitado(this.fechaConstitucionInput);
        }
      })
    }
    // ========== TERMINA CÓDIGO PARA VALIDACIÓN DE RFC MORAL ==========
    // ========== INICIA CÓDIGO PARA INFERIR DATOS DESDE CURP ==========
    const curpControl = this.QuintoFormGroup.get('curp');
    if (curpControl) {
      const curpField = this.elementRef.nativeElement.querySelector('[formControlName="curp"]');

      // Escuchar el evento 'blur' del campo CURP
      fromEvent(curpField, 'blur').pipe(
        filter(() => curpControl.valid && curpControl.value.length === 18), // Continuar solo si la CURP es válida y completa
        map(() => curpControl.value),
        // distinctUntilChanged(), // Evitar ejecuciones si el valor no ha cambiado
        takeUntil(this.destroy$)
      ).subscribe(() => {
        const datosInferidos = inferirDatosDesdeCurp(curpControl.value);

        const sexoControl = this.QuintoFormGroup.get('sexo');
        const fechaNacimientoControl = this.QuintoFormGroup.get('fechaNacimiento');

        if (datosInferidos && sexoControl && fechaNacimientoControl) {
          // Llenar los campos
          sexoControl.setValue(datosInferidos.sexo);
          fechaNacimientoControl.setValue(datosInferidos.fechaNacimiento);
          // this.SegundoGrupo.get('fechaConstitucion')?.setValue(fechaInferida);


          // Deshabilitar los campos y aplicar estilos
          this.aplicarEstilosDeshabilitado(this.sexoInput);
          this.aplicarEstilosDeshabilitado(this.fechaNacimientoInput);
        }
      });
      // Lógica para resetear si el usuario modifica la CURP y la hace inválida
      curpControl.valueChanges.pipe(
        filter(() => curpControl.invalid),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        const sexoControl = this.QuintoFormGroup.get('sexo');
        const fechaNacimientoControl = this.QuintoFormGroup.get('fechaNacimiento');

        if (curpControl.invalid) {
          sexoControl?.reset('');
          fechaNacimientoControl?.reset('');
          this.aplicarEstilosDeshabilitado(this.sexoInput);
          this.aplicarEstilosDeshabilitado(this.fechaNacimientoInput);
        }
      });
    }
    // ========== TERMINA CÓDIGO PARA INFERIR DATOS DESDE CURP ==========

  }

  aplicarEstilosDeshabilitado(elemento: ElementRef): void {
    if (elemento && elemento.nativeElement) {
      const el = elemento.nativeElement;
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.7';
      el.style.backgroundColor = '#f5f5f5';
      el.setAttribute('aria-disabled', 'true');
      el.tabIndex = -1;
    }
  }

  removerEstilosDeshabilitado(elemento: ElementRef): void {
    if (elemento && elemento.nativeElement) {
      const el = elemento.nativeElement;
      el.style.pointerEvents = 'auto';
      el.style.opacity = '1';
      el.style.backgroundColor = 'white';
      el.removeAttribute('aria-disabled');
      el.tabIndex = 0;
    }
  }

  //********************************************* VALIDACIONES REACTIVAS 2-3 ************************************************//

  get todosLosFormGroups(): FormGroup[] {
    return [this.PrimerFormGroup, this.SegundoGrupo, this.TercerFormGroup, this.CuartoFormGroup, this.QuintoFormGroup, this.SextoFormGroup, this.SeptimoFormGroup, this.OctavoFormControl];
  }

  private inicializarValidacionesReactivas(): void {
    this.todosLosFormGroups.forEach(formGroup => {
      Object.keys(formGroup.controls).forEach(campo => {
        const control = formGroup.get(campo);
        if (control) {
          control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.actualizarEstilosCampo(campo, control);
          });
        }
      });
    });
  }

  private actualizarEstilosCampo(campo: string, control: AbstractControl): void {
    const fieldElement = document.querySelector(`[formControlName="${campo}"]`);
    if (fieldElement) {
      if ((control.touched || control.dirty) ||
        ((campo === 'rfcMoral' || campo === 'fechaConstitucion' || campo === 'sexo' || campo === 'fechaNacimiento'
          || campo === 'estado' || campo === 'municipio') && control.valid)) {
        if (control.valid) {
          fieldElement.classList.remove('is-invalid');
          fieldElement.classList.add('is-valid');
        } else {
          fieldElement.classList.add('is-invalid');
          fieldElement.classList.remove('is-valid');
        }
      } else {
        fieldElement.classList.remove('is-valid', 'is-invalid');
      }
    }
  }

  //********************************************* STEPPER ************************************************//

  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let primerCampoInvalido: string | null = null;
    for (const campo of campos.nombres) {
      const control = campos.grupo.get(campo);
      if (!control || control.disabled) {
        continue;
      }
      if (control.invalid) {
        control.markAsTouched();
        if (!primerCampoInvalido) primerCampoInvalido = campo;
      }
      this.actualizarEstilosCampo(campo, control);
    }

    if (!primerCampoInvalido) {
      this.stepper.next();
    } else {
      Swal.fire({
        html: this.mensajeError(primerCampoInvalido),
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      const fieldElement = document.querySelector(`[formControlName="${primerCampoInvalido}"]`) as HTMLElement;
      fieldElement?.focus();
    }
  }

  //********************************************* MENSAJES PERSONALIZADOS ************************************************//

  /** Mensajes personalizados **/
  mensajeError(campo: string): string {
    const control = this.todosLosFormGroups.reduce((acc, fg) => acc || fg.get(campo), null as AbstractControl | null);
    if (control && control.errors) {
      if (control.errors['required']) {
        // Mensajes genéricos para 'required' pueden ser suficientes si los nombres de campo son claros
      }
      // Podrías añadir más lógica para errores específicos como pattern, minlength, etc.
    }


    const mensajes: any = {
      //seccion 1
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa:
        'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivo:
        'El campo <b> Motivo de Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor:
        'El campo <b> Certificado Por.. de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio:
        'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      categoria:
        'El campo <b> Categoria de los Datos del Vehículo </b> no debe estar vacío.',
      marca:
        'El campo <b> Marca de los Datos del Vehículo </b> no debe estar vacío.',
      submarca:
        'El campo <b> Submarca de los Datos del Vehículo </b> no debe estar vacío.',
      modelo:
        'El campo <b> Modelo de los Datos del Vehículo </b> no debe estar vacío.',
      motor:
        'El campo <b> Motor de los Datos del Vehículo </b> no debe estar vacío.',
      refrendo:
        'El campo <b> Refrendo de los Datos del Vehículo </b> no debe estar vacío.',
      repuve:
        'El campo <b> Repuve de los Datos del Vehículo </b> no debe estar vacío.',

      //seccion 2
      rfcMoral:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLL000000AAA',
      fechaConstitucion:
        'El campo <b> Fecha constitucion de los Datos de la empresa </b> no debe estar vacío.',
      razonSocial:
        'El campo <b> Razon social de los Datos de la empresa </b> no debe estar vacío.',

      //seccion 3
      calle:
        'El campo <b> Calle del Domicilio Fiscal </b> no debe estar vacío.',
      numExterior:
        'El campo <b> Numero Exterior del Domicilio Fiscal </b> no debe estar vacío.',
      codigoPostal:
        'El campo <b> Codigo Postal del Domicilio Fiscal </b> no debe estar vacío.',
      estado:
        'El campo <b> Estado del Domicilio Fiscal </b> debe estar seleccionado.',
      municipio:
        'El campo <b> Municipio del Domicilio Fiscal </b> debe estar seleccionado.',
      localidad:
        'El campo <b> Localidad del Domicilio Fiscal </b> debe estar seleccionado.',

      //seccion 4
      correoElectronico:
        'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto</b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono:
        'El campo <b> Número Teléfono de los Medios de Contacto  </b> debe contener 10 números.',

      //seccion 5
      rfc:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000AAA',
      curp:
        'Por favor verifica que el campo <b> CURP </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000LLLLLLA0',
      nombre:
        'El campo <b> Nombre de los Datos del Representante Legal </b> no debe estar vacío.',
      apellidoPaterno:
        'El campo <b> Apellido Paterno de los Datos del Representante Legal </b> no debe estar vacío.',
      apellidoMaterno:
        'El campo <b> Apellido Materno de los Datos del Representante Legal </b> no debe estar vacío.',
      sexo:
        'El campo <b> Sexo de los Datos del Representante Legal </b> no debe estar vacío.',
      fechaNacimiento:
        'El campo <b> Fecha Nacimiento de los Datos del Representante Legal </b> no debe estar vacío.',

      //seccion 6
      documentos:
        'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',
      actaConstitutiva:
        'El documento <b>Acta Constitutiva</b> no se ha seleccionado.',
      factura: 'El documento <b>Factura</b> no se ha seleccionado.',
      ine: 'El documento <b>INE REPRESENTANTE LEGAL</b> no se ha seleccionado.',
      poderNotarial:
        'El documento <b>Poder Notarial</b> no se ha seleccionado.',
      repuveDoc: 'El documento <b>REPUVE</b> no se ha seleccionado.',
      solicitud: 'El documento <b>Solicitud</b> no se ha seleccionado.',
      tenencia: 'El documento <b>Tenencia</b> no se ha seleccionado.',
    };
    return mensajes[campo] || `El campo ${campo.replace(/([A-Z])/g, ' $1').toLowerCase()} es no valido o está incompleto.`;
  }

  resetearFormularios(): void {
    console.log('Reseteando todos los formularios y el stepper...');
    this.todosLosFormGroups.forEach(formGroup => {
      if (formGroup) {
        formGroup.reset();
        formGroup.enable();
      }
    });
    if (this.stepper) {
      this.stepper.reset();
    }
  }

  private getListlocalidad(codigoPostal: string): void {
    // Si el código postal está vacío, reseteamos los valores relacionados
    if (!codigoPostal || codigoPostal.trim() === '') {
      this.resetLocalidadData();
      return;
    }
    // Llamada al servicio para obtener las localidades del código postal
    this.catalogoDomicilioGenerico.getlocalidad(codigoPostal).subscribe((postal: any) => {
      this.cp = postal;

      // Si no se encontraron resultados (array vacío)
      if (!postal || postal.length === 0) {
        console.warn("⚠️ No se encontraron datos para el código postal ingresado.");
        Swal.fire({
          html: 'No se encontraron datos para el Código Postal ingresado.',
          icon: 'warning',
          confirmButtonColor: '#41bd00',
          confirmButtonText: 'Aceptar'
        });

        this.resetLocalidadData(); // Restablecemos los datos si no hay resultados
        return;
      }

      // 🔹 Guardamos los datos obtenidos
      this.localidad = postal;
      const primerRegistro = this.localidad[0];
      this.municipio = primerRegistro.descripcionIdMunicipioCodigoPostal;
      this.estado = primerRegistro.descripcionidEstadoPais;
      this.idMunicipio = primerRegistro.idMunicipioCodigoPostal;
      this.idEstado = primerRegistro.idEstadoPais;

      if (this.estado.toUpperCase() === 'TLAXCALA') {
        Swal.fire({
          icon: 'error',
          title: 'Estado no Válido',
          // Mensaje mejorado para guiar al usuario
          text: 'Este es un trámite para vehículos foráneos. Si su domicilio fiscal está en TLAXCALA, por favor utilice el trámite para vehículos ESTATALES.',
          confirmButtonColor: '#41bd00',
          confirmButtonText: 'Confirmar',
        });

        // Reseteamos los datos del domicilio y también el campo de código postal
        this.resetLocalidadData();
        this.TercerFormGroup.get('codigoPostal')?.setValue('');
        return; // Detenemos la ejecución para no autocompletar el formulario.
      }

      // 🔹 Actualizar Formulario Reactivo (`tresFormGroup`)
      this.TercerFormGroup.patchValue({
        estado: this.estado,
        municipio: this.municipio,
        localidad: '' // ❗ Forzamos a que localidad esté vacía
      });

      // ❗ Marcar localidad como "pendiente" para que NO sea válida automáticamente
      // this.TercerFormGroup.get('localidad')?.markAsPending();
    });
  }

  /**
   * Méto do para limpiar la información relacionada con el código postal.
   */
  private resetLocalidadData(): void {
    // Limpiar datos relacionados en el componente
    this.localidad = [];
    this.cp = null;
    this.municipio = '';
    this.estado = '';
    this.idMunicipio = '';

    // Reiniciar valores del formulario
    this.TercerFormGroup.patchValue({
      estado: '',
      municipio: '',
      localidad: ''
    });

    // console.log("ℹ️ Datos de localidad reiniciados debido a un código postal vacío.");
  }

  // Método para gestionar cambios en el código postal
  private cambiarEstadoConCodigoPostal(): void {
    const codigoPostalControl = this.TercerFormGroup.get('codigoPostal');

    // Detectar cambios en el campo de código postal
    codigoPostalControl?.valueChanges.subscribe((valor: string) => {
      const estadoControl = this.TercerFormGroup.get('estado');
      const municipioControl = this.TercerFormGroup.get('municipio');
      const localidadControl = this.TercerFormGroup.get('localidad');

      // Validar si el código postal no es válido o tiene menos de 5 caracteres
      if (!codigoPostalControl.valid || valor.length < 5) {
        // Limpia los campos relacionados
        estadoControl?.setValue('');
        municipioControl?.setValue('');
        localidadControl?.setValue('');

        // Marcar los campos como no válidos
        estadoControl?.setErrors({invalid: true});
        municipioControl?.setErrors({invalid: true});
        localidadControl?.setErrors({invalid: true});

        // Opcional: Mostrar mensajes de error al usuario
        estadoControl?.markAsTouched();
        municipioControl?.markAsTouched();
        localidadControl?.markAsTouched();
      } else {
        // Si el código postal es válido, eliminar errores
        estadoControl?.setErrors(null);
        municipioControl?.setErrors(null);
        localidadControl?.setErrors(null);
      }
    });
  }

  nextButtonClick() {
    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: ['niv', 'placa', 'motivo', 'certificadoPor', 'tipoServicio', 'categoria', 'marca', 'submarca', 'modelo', 'motor', 'refrendo', 'repuve'],
    });
  }

  nextButtonClick2() {
    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['rfcMoral', 'fechaConstitucion', 'razonSocial'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['calle', 'numExterior', 'numInterior', 'codigoPostal', 'estado', 'municipio', 'localidad'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['numeroTelefono', 'correoElectronico'],
    });
  }

  nextButtonClick5() {
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['rfc', 'curp', 'nombre', 'apellidoPaterno', 'apellidoMaterno', 'sexo', 'fechaNacimiento'],
    });
  }

  nextButtonClick6() {
    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: ['documentos'],
    });
  }

  nextButtonClick7() {
    this.validarYContinuar({
      grupo: this.SeptimoFormGroup,
      nombres: [
        'actaConstitutiva',
        'factura',
        'ine',
        'poderNotarial',
        'repuveDoc',
        'solicitud',
        'tenencia'
      ],
    });
  }

  nextButtonClick8() {
    // Validar términos y condiciones
    const terminosControl = this.OctavoFormControl.get('terminosCondiciones');
    terminosControl?.markAsTouched();
    this.actualizarEstilosCampo('terminosCondiciones', terminosControl!);
    if (this.OctavoFormControl.invalid) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return;
    }

    // Validar todos los formularios anteriores
    for (const fg of this.todosLosFormGroups.slice(0, -1)) { // Excluye el último form group de términos
      if (fg.invalid) {
        Swal.fire({
          html: 'Formulario Incompleto, Por favor, revise los pasos anteriores. Hay campos obligatorios sin llenar o con errores.',
          icon: 'error',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
        });
        return;
      }
    }

    // Si todo es válido, mostrar confirmación
    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.mostrarSpinner = true;
        const correo = this.CuartoFormGroup.get('correoElectronico')?.value;
        const idLocalidadSeleccionada = this.TercerFormGroup.get('localidad')?.value;
        const localidadSeleccionadaObj = this.localidad.find(loc => loc.idCodigoPostal == idLocalidadSeleccionada);
        const nombreLocalidad = localidadSeleccionadaObj ? localidadSeleccionadaObj.asentamiento : '';

        const datosParaBackend: PayloadMoralForanea = {
          // Vehículo
          strNiv: this.PrimerFormGroup.get('niv')?.value,
          strPlaca: this.PrimerFormGroup.get('placa')?.value,
          intIdMotivoSolicitud: this.PrimerFormGroup.get('motivo')?.value,
          intIdCertificadoPor: this.PrimerFormGroup.get('certificadoPor')?.value,
          intIdTipoServicio: this.PrimerFormGroup.get('tipoServicio')?.value,
          strCategoria: this.PrimerFormGroup.get('categoria')?.value,
          strMarca: this.PrimerFormGroup.get('marca')?.value,
          strSubMarca: this.PrimerFormGroup.get('submarca')?.value,
          strModelo: this.PrimerFormGroup.get('modelo')?.value,
          strMotor: this.PrimerFormGroup.get('motor')?.value,
          strRefrendo: this.PrimerFormGroup.get('refrendo')?.value,
          strRepuve: this.PrimerFormGroup.get('repuve')?.value,
          intIdTipoTramite: 2, // 1 para Estatal, 2 para Foráneo

          // Empresa
          strRfc: this.SegundoGrupo.get('rfcMoral')?.value.toUpperCase(),
          // strCurp: '', // El JSON lo pide, se manda vacío para morales.
          strRazonSocial: this.SegundoGrupo.get('razonSocial')?.value,
          strFechaConstitucion: this.SegundoGrupo.get('fechaConstitucion')?.value,

          // Representante Legal
          strRfcRepresentante: this.QuintoFormGroup.get('rfc')?.value.toUpperCase(),
          strCurpRepresentante: this.QuintoFormGroup.get('curp')?.value.toUpperCase(),
          strNombreRepresentante: this.QuintoFormGroup.get('nombre')?.value,
          strApPaternoRepresentante: this.QuintoFormGroup.get('apellidoPaterno')?.value,
          strApMaternoRepresentante: this.QuintoFormGroup.get('apellidoMaterno')?.value,
          strSexoRepresentante: this.QuintoFormGroup.get('sexo')?.value,
          strFechaNacimientoRepresentante: this.QuintoFormGroup.get('fechaNacimiento')?.value,

          // Domicilio Fiscal
          strCalleFiscal: this.TercerFormGroup.get('calle')?.value,
          strNumeroExteriorFiscal: this.TercerFormGroup.get('numExterior')?.value,
          strNumeroInteriorFiscal: this.TercerFormGroup.get('numInterior')?.value,
          strCodigoPostalFiscal: this.TercerFormGroup.get('codigoPostal')?.value,
          strEstadoFiscal: this.TercerFormGroup.get('estado')?.value,
          strMunicipioFiscal: this.TercerFormGroup.get('municipio')?.value,
          strLocalidadFiscal: nombreLocalidad, // <-- Se envía el NOMBRE
          intIdCodigoPostalCg: +idLocalidadSeleccionada, // <-- Se envía el ID numérico
          intIdEstadoFiscal: parseInt(this.idEstado),
          intIdMunicipioFiscal: parseInt(this.idMunicipio),
          intIdLocalidadFiscal: this.TercerFormGroup.get('localidad')?.value,

          // Contacto
          strTelefono: this.CuartoFormGroup.get('numeroTelefono')?.value,
          strEmail: this.CuartoFormGroup.get('correoElectronico')?.value,
        };

        this.mostrarSpinner = false; // Ocultar spinner si la llamada fuera síncrona (o después del setTimeout)
        this.solicitudService.solicitarCertificdoMoralForaneo(datosParaBackend).subscribe({
          next: (respuesta) => {
            this.mostrarSpinner = false;
            Swal.fire({
              icon: 'success',
              title: 'Solicitud enviada',
              html: `Su solicitud ha sido enviada correctamente. <br><br> Se ha enviado un correo electrónico a <b style="color: #A11A5C">${correo}</b> para darle seguimiento. <hr>Le recomendamos revisar su bandeja de entrada y la carpeta de spam.`,
              confirmButtonColor: '#04B404',
              confirmButtonText: 'Confirmar',
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.resetearFormularios();
                this.router.navigate(['https://tlaxcallan.sefintlax.gob.mx/tlaxcallan']);
              }
            });
          },
          error: (error) => {
            this.mostrarSpinner = false;
            const backendMessage = error.error?.message || error.error?.strMensaje || error.message;
            Swal.fire('Error al Enviar', 'Hubo un problema al enviar la solicitud: ' + (backendMessage || 'Error desconocido. Intente más tarde.'), 'error');
          }
        });
      } else {
        // El usuario hizo clic en "No", no hacemos nada.
        console.log('El guardado fue cancelado por el usuario.');
        this.mostrarSpinner = false;
      }
    });
  }


  documentos = [
    {
      id: '1',
      idDocumentoBack: '',
      titulo: 'ACTA CONSTITUTIVA',
      formControlName: 'actaConstitutiva',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '3',
      idDocumentoBack: '',
      titulo: 'FACTURA',
      formControlName: 'factura',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    }, // Corregido ID para coincidir con formControlName
    {
      id: '5',
      idDocumentoBack: '',
      titulo: 'INE REPRESENTANTE LEGAL',
      formControlName: 'ine',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '6',
      idDocumentoBack: '',
      titulo: 'PODER NOTARIAL',
      formControlName: 'poderNotarial',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '7',
      idDocumentoBack: '',
      titulo: 'REPUVE',
      formControlName: 'repuveDoc',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    }, // formControlName para el documento REPUVE
    {
      id: '8',
      idDocumentoBack: '',
      titulo: 'SOLICITUD',
      formControlName: 'solicitud',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '9',
      idDocumentoBack: '',
      titulo: 'TENENCIA Y/O REFRENDO',
      formControlName: 'tenencia',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
  ];

  //********************************** MÉTODOS PARA DOCUMENTOS - ACTA CONSTITUTIVA *********************************************//

  onFileSelected(input: HTMLInputElement, doc: any): void {
    const nuevoArchivo = input.files?.[0];
    if (!nuevoArchivo) return;

    // --- Lógica de validación del archivo (sin cambios) ---
    if (nuevoArchivo.type !== 'application/pdf') { /* ... Swal error ... */
      return;
    }
    const maxSizeMB = 10;
    if (nuevoArchivo.size > maxSizeMB * 1024 * 1024) { /* ... Swal error ... */
      return;
    }

    const rfc = this.SegundoGrupo.get('rfcMoral')?.value;
    if (!rfc) { /* ... Swal error ... */
      return;
    }

    // ====================================================================
    // ===== INICIA LÓGICA: ¿REEMPLAZAR O SUBIR POR PRIMERA VEZ? =====
    // ====================================================================

    if (doc.estadoSubida === 'COMPLETADO') {
      // Si ya hay un archivo, preguntamos al usuario si quiere reemplazarlo.
      Swal.fire({
        title: '¿Reemplazar archivo?',
        text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#41bd00',
        cancelButtonColor: '#C71128',
        confirmButtonText: 'Sí, reemplazar',
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // El usuario quiere reemplazar. Primero eliminamos, luego subimos.
          this.eliminarYSubir(doc, nuevoArchivo, rfc, input);
        } else {
          // El usuario canceló, limpiamos el input para que no quede el archivo seleccionado.
          input.value = '';
        }
      });
    } else {
      // Si no hay un archivo previo, simplemente lo subimos.
      this.subirNuevoDocumento(doc, nuevoArchivo, rfc, input);
    }
  }

  /**
   * Orquesta la eliminación del archivo antiguo y luego la subida del nuevo.
   */
  private eliminarYSubir(doc: any, nuevoArchivo: File, rfc: string, input: HTMLInputElement): void {
    Swal.fire({
      title: 'Eliminando archivo anterior...',
      didOpen: () => Swal.showLoading(),
      showConfirmButton: false
    });
    this.eliminarDocumentoService.eliminarDocumentos(doc.idDocumentoBack as number, rfc, doc.nombreEncriptado)
      .pipe(
        // switchMap encadena la llamada de subida DESPUÉS de que la eliminación sea exitosa
        switchMap(() => {
          Swal.update({text: 'Subiendo nuevo archivo...'});
          return this.documentoService.subirDocumentoPdf(rfc, doc.id, nuevoArchivo);
        })
      ).subscribe({
      next: (event: HttpEvent<any>) => this.manejarEventosDeSubida(event, doc, nuevoArchivo),
      error: err => {
        Swal.fire('Error', 'No se pudo eliminar el archivo anterior. La subida del nuevo archivo ha sido cancelada.', 'error');
        doc.estadoSubida = 'ERROR';
        input.value = '';
      }
    });
  }

  /**
   * Sube un documento que no tiene un predecesor a eliminar.
   */
  private subirNuevoDocumento(doc: any, nuevoArchivo: File, rfc: string, input: HTMLInputElement): void {
    doc.estadoSubida = 'CARGANDO';
    this.isUploading[doc.id] = true;
    this.uploadProgress[doc.id] = 0;
    this.documentoService.subirDocumentoPdf(rfc, doc.id, nuevoArchivo).subscribe({
      next: (event: HttpEvent<any>) => this.manejarEventosDeSubida(event, doc, nuevoArchivo),
      error: err => {
        doc.estadoSubida = 'ERROR';
        this.isUploading[doc.id] = false;
        input.value = '';
        Swal.fire('Error de Subida', `No se pudo subir el documento: ${doc.titulo}.`, 'error');
      }
    });
  }

  /**
   * Lógica centralizada para manejar los eventos de progreso y respuesta de la subida.
   */
  private manejarEventosDeSubida(event: HttpEvent<any>, doc: any, archivo: File): void {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        if (event.total) {
          this.uploadProgress[doc.id] = Math.round(100 * (event.loaded / event.total));
        }
        break;
      case HttpEventType.Response:
        this.uploadProgress[doc.id] = 100;
        doc.estadoSubida = 'COMPLETADO';
        this.isUploading[doc.id] = false;

        // Guardamos los datos importantes de la respuesta en nuestro objeto 'doc'
        doc.nombreEncriptado = event.body.identificador;
        doc.idDocumentoBack = event.body.idDocumento;

        // Actualizamos el FormGroup para que el campo sea válido
        this.SeptimoFormGroup.get(doc.formControlName)?.setValue(doc.idDocumentoBack);
        this.SeptimoFormGroup.get(doc.formControlName)?.updateValueAndValidity();

        // Generamos la vista previa
        const localUrlString = URL.createObjectURL(archivo);
        doc.rawUrl = localUrlString;
        doc.urlVisor = this.sanitizer.bypassSecurityTrustResourceUrl(localUrlString);

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `${doc.titulo} subido con éxito`,
          showConfirmButton: false,
          timer: 3000
        });
        break;
    }
  }

  verDocumentoEnVentana(doc: any): void {
    // Verificamos que la propiedad rawUrl (que ahora es la URL local) exista
    if (doc && doc.rawUrl) {
      window.open(doc.rawUrl, '_blank');
    } else {
      Swal.fire({
        icon: 'info',
        title: 'No disponible',
        text: 'Primero debe seleccionar un archivo para poder visualizarlo.'
      });
    }
  }

  // ***************************************************METODOS PARA CHECK BOTON*************************************************************


  //*********************************************-MODALES RFC Y CURP-************************************************//

  modalRFCmoral() {
    Swal.fire({
      background: 'rgba(66, 43, 124)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCMORAL.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
                animate__animated
                animate__fadeInUp
                animate__faster
              `,
      },
      hideClass: {
        popup: `
                      animate__animated
                      animate__fadeOutDown
                      animate__faster
                    `,
      },
    });
  }

  //---------------------------------------------------------------------------------------
  modalRFC() {
    Swal.fire({
      background: 'rgba(66, 43, 124)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
                animate__animated
                animate__fadeInUp
                animate__faster
              `,
      },
      hideClass: {
        popup: `
                      animate__animated
                      animate__fadeOutDown
                      animate__faster
                    `,
      },
    });
  }

  //---------------------------------------------------------------------------------------
  modalCURP() {
    Swal.fire({
      background: 'rgba(66, 43, 124)',
      imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
                animate__animated
                animate__fadeInUp
                animate__faster
              `,
      },
      hideClass: {
        popup: `
                      animate__animated
                      animate__fadeOutDown
                      animate__faster
                    `,
      },
    });
  }

  //*********************************************Méto do que "transfiere" valor automáticamente del RFC al CURP************************************************//
  pasarValorRfcACurp(): void {
    const rfcControl = this.QuintoFormGroup.get('rfc');
    const curpControl = this.QuintoFormGroup.get('curp');

    if (rfcControl && curpControl) {
      const rfcValue = (rfcControl.value || '').toUpperCase();

      // Si el RFC tiene al menos 10 caracteres, copia esa parte al CURP
      if (rfcValue.length >= 10) {
        curpControl.setValue(rfcValue.substring(0, 10));
      } else {
        curpControl.setValue(rfcValue); // Si no, copia lo que haya
      }
    }
  }

  //*********************************************TERMINA - MODALES RFC Y CURP-************************************************//

  descargarDocumento() {

    // 1. Mostrar un indicador de carga
    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });

    // 2. Recolectar todos los datos desde tus formularios
    // NOTA: Asegúrate de que los nombres de los formControlName coincidan
    const nombreCompleto = `${this.QuintoFormGroup.get('nombre')?.value}  ${this.QuintoFormGroup.get('apellidoPaterno')?.value} ${this.QuintoFormGroup.get('apellidoMaterno')?.value}`;
    const rfc = this.SegundoGrupo.get('rfcMoral')?.value;
    const rfcReprecentante = this.QuintoFormGroup.get('rfc')?.value;
    const razonSocial = this.SegundoGrupo.get('razonSocial')?.value;
    const curp = this.QuintoFormGroup.get('curp')?.value; // O el que corresponda
    const domicilio = `${this.TercerFormGroup.get('calle')?.value} ${this.TercerFormGroup.get('numExterior')?.value}`;
    const municipio = this.TercerFormGroup.get('municipio')?.value;
    const estado = this.TercerFormGroup.get('estado')?.value;

    const certificadoId = this.PrimerFormGroup.get('certificadoPor')?.value;
    const certificadoSeleccionado = this.coberturaCertificados.find(
      certificado => certificado.id_cobertura_certificado == certificadoId
    );
    const garantias = certificadoSeleccionado ? certificadoSeleccionado.certificado_por : '';

    const niv = this.PrimerFormGroup.get('niv')?.value;
    const placa = this.PrimerFormGroup.get('placa')?.value;
    const marca = this.PrimerFormGroup.get('marca')?.value;
    const estadoVehiculo = this.estado

    const modelo = this.PrimerFormGroup.get('modelo')?.value;
    const refrendo = this.PrimerFormGroup.get('refrendo')?.value;
    let tipoServicio: string;
    if (this.PrimerFormGroup.get('tipoServicio')?.value === '1') {
      tipoServicio = "PÚBLICO";
    } else {
      tipoServicio = "PRIVADO";
    }
    const motor = this.PrimerFormGroup.get('motor')?.value;
    const repuve = this.PrimerFormGroup.get('repuve')?.value;
    const tipoPersona = 'M';

    // 3. Llamar al servicio con todos los datos recolectados
    this.imprimirSolicitudService.imprimirSolicitudCdniGenerico(
      nombreCompleto, rfc, rfcReprecentante, razonSocial, curp, domicilio, municipio, estado, garantias, niv,
      placa, marca, estadoVehiculo, modelo, refrendo, tipoServicio, motor, repuve, tipoPersona
    ).subscribe({
      next: (data: Blob) => {
        // 4. Lógica para procesar la respuesta y descargar el archivo
        Swal.close(); // Cerrar el indicador de carga
        const blob = new Blob([data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);

        // Crear un enlace temporal para iniciar la descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Solicitud_No_Infraccion.pdf'; // Nombre del archivo

        // Simular clic en el enlace y luego removerlo
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        // Limpiar la URL del objeto creado para liberar memoria
        window.URL.revokeObjectURL(url);
        link.remove();
      },
      error: (error) => {
        console.error(error);
        Swal.fire({
          icon: 'error',
          title: 'Error en la descarga',
          text: 'No se pudo generar el documento. Por favor, inténtelo de nuevo más tarde.'
        });
      }
    });
  }


  catCoberturaCertificados() {
    this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
      next: (data: any) => {
        this.coberturaCertificados = data;
      }
    });
  }


  catEfectoCertificado() {
    this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
      next: (data: any) => {
        this.efectosCertificados = data;
      }
    });
  }


  onChangeCoberturaCertificados(event: any) {
    this.solicitudVo.strCertificadoPor = event.target.value;
  }

  onChangeTipoServicio(event: any) {
    this.solicitudVo.strTipoServicio = event.target.value;
  }

  onChangeEfectoCertificado(event: any) {
    this.solicitudVo.strMotivoSolicitud = event.target.value;
  }

}

function inferirFechaConstitucion(rfc: string): string | null {
  // 1. Validar que el RFC sea una cadena y tenga 12 caracteres.
  if (typeof rfc !== 'string' || rfc.length !== 12) {
    console.error();
    return null;
  }

  try {
    // 2. Extraer la subcadena YYMMDD (posiciones 3 a 8).
    const fechaSubstr = rfc.substring(3, 9);

    // 3. Separar las partes de la fecha.
    const anioDosDigitos = parseInt(fechaSubstr.substring(0, 2), 10);
    const mes = fechaSubstr.substring(2, 4);
    const dia = fechaSubstr.substring(4, 6);

    // 4. Determinar el siglo.
    const anioActualDosDigitos = new Date().getFullYear() % 100;
    const siglo = (anioDosDigitos > anioActualDosDigitos) ? '19' : '20';

    // 5. Formatear la fecha final en YYYY-MM-DD.
    const anioCompleto = siglo + anioDosDigitos.toString().padStart(2, '0');

    const fechaFormateada = `${anioCompleto}-${mes}-${dia}`;

    // Opcional: Validar que la fecha construida sea una fecha real.
    const fechaObjeto = new Date(fechaFormateada);
    if (isNaN(fechaObjeto.getTime())) {

      return null;
    }

    return fechaFormateada;

  } catch (error) {
    console.error(error);
    return null;
  }
}

function inferirDatosDesdeCurp(curp: string): { sexo: string, fechaNacimiento: string } | null {
  // 1. Validar que la CURP sea una cadena y tenga 18 caracteres.
  if (typeof curp !== 'string' || curp.length !== 18) {
    return null;
  }

  try {
    // 2. Extraer las partes de la fecha (YYMMDD) y el sexo.
    const fechaSubstr = curp.substring(4, 10);
    const sexoChar = curp.charAt(10).toUpperCase();

    // 3. Inferir el siglo para el año de nacimiento
    const anioDosDigitos = parseInt(fechaSubstr.substring(0, 2), 10);
    const diferenciadorSiglo = curp.charAt(16);
    // Si el caracter en la posición 17 es una letra, es del año 2000 en adelante.
    const siglo = isNaN(parseInt(diferenciadorSiglo)) ? '20' : '19';
    const anioCompleto = siglo + anioDosDigitos.toString().padStart(2, '0');

    // 4. Formatear la fecha a DD-MM-AAAA como solicitaste
    const mes = fechaSubstr.substring(2, 4);
    const dia = fechaSubstr.substring(4, 6);
    const fechaFormateada = `${anioCompleto}-${mes}-${dia}`;

    // 5. Determinar el sexo
    const sexo = sexoChar === 'H' ? 'MASCULINO' : 'FEMENINO';

    // 6. Validar que la fecha construida sea real
    const fechaObjeto = new Date(`${anioCompleto}-${mes}-${dia}`);
    if (isNaN(fechaObjeto.getTime())) {
      return null;
    }

    return {
      sexo: sexo,
      fechaNacimiento: fechaFormateada
    };

  } catch (error) {
    return null;
  }
}